import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "loan-configuration-section-wrapper" }
const _hoisted_2 = { class: "info-section" }
const _hoisted_3 = { class: "info-value" }
const _hoisted_4 = { class: "info-section" }
const _hoisted_5 = { class: "info-title" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "info-value" }
const _hoisted_8 = { class: "info-section" }
const _hoisted_9 = { class: "info-title" }
const _hoisted_10 = { style: {"margin-bottom":"20px"} }
const _hoisted_11 = { class: "info-value" }

import { computed } from "vue";
import { useStore } from "vuex";
import { ApplicationStatusTypeIds } from "@/config/constants";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import Icon from "@/components/shared/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RefiLoanConfigurationDetails',
  setup(__props) {

const store = useStore();
const applicationInfo = computed(() => store?.state?.applicationInfoModule?.applicationInfo);
const consentsModule = computed(() => store.state);
const consentsModuleGetters = computed(() => store.getters);
const applicationStatusId = computed(() => store.state.appData?.application?.applicationStatusId);

const preApprovedAmountDisplay = computed(() =>
  applicationInfo.value?.preApprovedAmount
    ? applicationInfo.value?.preApprovedAmount
    : "Not Selected",
);
const interestRateAndLoanTermDisplay = computed(() =>
  applicationInfo.value?.rate &&
  applicationInfo.value?.term &&
  applicationInfo.value?.rate !== "Not Selected" &&
  applicationInfo.value?.term !== "Not Selected"
    ? `${applicationInfo.value?.rate} | ${applicationInfo.value?.term}`
    : "Not Selected",
);
const estimatedMonthlyPaymentDisplay = computed(() =>
  applicationInfo.value?.estimatedMonthlyPayment
    ? applicationInfo.value?.estimatedMonthlyPayment
    : "Not Selected",
);

const canEdit = computed(() => applicationInfo.value?.canEdit);

function openModal(modal: string) {
  store.dispatch("applicationInfoModule/openModal", modal);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "info-title" }, "Pre-Approved Refinance Loan Amount", -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(preApprovedAmountDisplay.value), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Interest Rate & Loan Term", -1)),
        (canEdit.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "edit-link",
              disabled: !canEdit.value,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openModal('InterestRateAndLoanTerm')), ["prevent"]))
            }, "Edit", 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(interestRateAndLoanTermDisplay.value), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", _hoisted_9, [
        _cache[4] || (_cache[4] = _createTextVNode(" Estimated Monthly Payment ", -1)),
        _createElementVNode("span", _hoisted_10, [
          _createVNode(TooltipComponent, { class: "md-bottom-center" }, {
            toggle: _withCtx(() => [
              _createElementVNode("b", null, [
                _createVNode(Icon, { icon: "info" })
              ])
            ]),
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, " Payment Estimates – See Your Approval Disclosure in your Legal Packet and your Final Disclosure for more details. Actual payment amounts will vary based on the number of days in a month and any variable interest rate. ", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("p", _hoisted_11, _toDisplayString(estimatedMonthlyPaymentDisplay.value), 1)
    ])
  ]))
}
}

})